export default "__VITE_ASSET__andRVp0G__"